var exports = {};

// see http://jsperf.com/testing-value-is-primitive/7
exports = function isPrimitive(value) {
  return value == null || typeof value !== "function" && typeof value !== "object";
};

export default exports;